import tfaStatuses from "@/constants/tfa-status/index"

const tfaGuard = (meta) => meta.dispatch(tfaGuardAction(meta));

const tfaGuardAction = (to) => (_dispatch, getState) => {

	const state = getState()

	if (state.auth.token && state.auth.tfa === tfaStatuses.setUp) {
		return '/setup-tfa'
	}

	if (state.auth.token && state.auth.tfa === tfaStatuses.otp) {
		return '/login'
	}

	return null
}

export { tfaGuard }
